import type { ReactNode } from 'react';
import { useAuth } from './useAuth';
import type { RoleToken } from './types';

export function RoleGuard({
  allowedRoles,
  children,
  fallback = null,
}: {
  allowedRoles: RoleToken[];
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const { roles, isAuthenticated } = useAuth();
  if (!isAuthenticated) return <>{fallback}</>;
  const allowed = roles.some((r) => allowedRoles.includes(r));
  return <>{allowed ? children : fallback}</>;
}